import { getPostCover } from '@wix/communities-forum-client-commons/dist/src/services/get-post-cover';

export const shouldRenderCover = (post = {}) => getPostCover(post).shouldRender;
